import React from 'react'
import icon from '../../../assets/icon/success.svg'

const IconSuccess = () => {
  return <img src={icon} alt="pdf-download" width="20px" height="20px" />
}

export default IconSuccess
